"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerCaps = exports.a = exports.paraSmall = exports.paraBig = exports.subTextSmall = exports.subTextSelected = exports.subText = exports.buttonText = exports.bodyText = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = void 0;

var _reactEmotion = require("react-emotion");

var h1 = function h1(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:32px;font-weight:normal;line-height:normal;color:", props.theme.color.black1, ";margin:0;")
  );
};

exports.h1 = h1;

var h2 = function h2(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:28px;font-weight:normal;line-height:normal;color:", props.theme.color.black1, ";margin:0;")
  );
};

exports.h2 = h2;

var h3 = function h3(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:24px;font-weight:normal;line-height:normal;color:", props.theme.color.black1, ";margin:0;")
  );
};

exports.h3 = h3;

var h4 = function h4(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:20px;font-weight:600;line-height:normal;color:", props.theme.color.black1, ";margin:0;")
  );
};

exports.h4 = h4;

var h5 = function h5(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:18px;font-weight:600;line-height:normal;color:", props.theme.color.black1, ";margin:0;")
  );
};

exports.h5 = h5;

var bodyText = function bodyText(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:16px;font-weight:normal;line-height:normal;color:", props.theme.color.black1, ";margin:0;")
  );
};

exports.bodyText = bodyText;

var buttonText = function buttonText(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:16px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.3px;color:", props.theme.color.accent, ";margin:0;")
  );
};

exports.buttonText = buttonText;

var subText = function subText(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:14px;font-weight:normal;line-height:normal;color:", props.theme.color.black1, ";margin:0;")
  );
};

exports.subText = subText;

var subTextSelected = function subTextSelected(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:14px;font-weight:600;line-height:normal;color:", props.theme.color.black1, ";margin:0;")
  );
};

exports.subTextSelected = subTextSelected;

var subTextSmall = function subTextSmall(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:12px;font-weight:normal;line-height:normal;color:", props.theme.color.black3, ";margin:0;")
  );
};

exports.subTextSmall = subTextSmall;

var paraBig = function paraBig(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:16px;font-weight:400;line-height:1.44;color:", props.theme.color.black1, ";")
  );
};

exports.paraBig = paraBig;

var paraSmall = function paraSmall(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:14px;font-weight:400;line-height:1.5;color:", props.theme.color.black1, ";")
  );
};

exports.paraSmall = paraSmall;

var a = function a(props) {
  var color = props.theme.color.accent;

  switch (props['link-type']) {
    case 'danger':
      color = props.theme.color.red;
      break;

    case 'success':
      color = props.theme.color.green;
      break;

    case 'warning':
      color = props.theme.color.yellow;
      break;

    default:
      color = props.theme.color.accent;
  }

  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:14px;font-weight:400;line-height:1.5;color:", color, ";cursor:pointer;&:hover{text-decoration:underline;}")
  );
};

exports.a = a;

var headerCaps = function headerCaps(props) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:12px;font-weight:500;letter-spacing:0.9px;text-transform:uppercase;color:", props.theme.color.black3, ";")
  );
};

exports.headerCaps = headerCaps;